import { Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { useWishlist } from '../../context/WishlistContext';
import { useCurrency } from '../../context/CurrencyContext';
import { useState, useEffect } from 'react';
import SearchModal from '../../components/feature/SearchModal';

export default function HomePage() {
  const { totalItems } = useCart();
  const { totalItems: wishlistTotal } = useWishlist();
  const { convertPrice } = useCurrency();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [collectionDropdownOpen, setCollectionDropdownOpen] = useState(false);
  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false);
  const [hasShownPopup, setHasShownPopup] = useState(false);
  const [subscriptionEmail, setSubscriptionEmail] = useState('');
  const [subscriptionStatus, setSubscriptionStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const heroImages = [
    'https://public.readdy.ai/ai/img_res/301c5cee2d02dc5a056c8a2c77640381.jpg',
    'https://readdy.ai/api/search-image?query=full%20body%20shot%20professional%20fashion%20editorial%20photography%20confident%20male%20model%20wearing%20premium%20quality%20grey%20heather%20cotton%20hoodie%20with%20large%20bold%20white%20sans-serif%20text%20reading%20Be%20SOMETHING%20prominently%20printed%20centered%20on%20chest%20area%20text%20measures%20approximately%20ten%20centimeters%20in%20width%20standing%20in%20modern%20minimalist%20concrete%20urban%20environment%20with%20natural%20daylight%20high%20resolution%20sharp%20focus%20showcasing%20hoodie%20fit%20and%20fabric%20drape%20luxury%20streetwear%20campaign%20aesthetic&width=1920&height=1080&seq=besomethinggreyhoodiefullbodyv1&orientation=landscape',
    'https://readdy.ai/api/search-image?query=full%20body%20shot%20professional%20fashion%20editorial%20photography%20confident%20male%20model%20wearing%20premium%20quality%20navy%20blue%20cotton%20hoodie%20with%20large%20bold%20white%20sans-serif%20text%20reading%20Knock%20it%20off%20exclamation%20mark%20prominently%20printed%20centered%20on%20chest%20area%20text%20measures%20approximately%20ten%20centimeters%20in%20width%20standing%20in%20professional%20photography%20studio%20with%20clean%20white%20or%20light%20grey%20backdrop%20studio%20lighting%20high%20resolution%20sharp%20focus%20showcasing%20hoodie%20fit%20and%20fabric%20drape%20luxury%20streetwear%20campaign%20aesthetic&width=1920&height=1080&seq=knockitoffnavyhoodiestudiov1&orientation=landscape'
  ];

  // Slideshow effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (hasShownPopup) return;
      
      const scrollPosition = window.scrollY + window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      // Show popup when user scrolls to bottom (within 100px)
      if (documentHeight - scrollPosition < 100) {
        setShowSubscriptionPopup(true);
        setHasShownPopup(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasShownPopup]);

  const handleSubscriptionSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubscriptionStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('email', subscriptionEmail);

      const response = await fetch('https://readdy.ai/api/form/d4lakacu6ftm2u5dbbl0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubscriptionStatus('success');
        setSubscriptionEmail('');
        setTimeout(() => {
          setShowSubscriptionPopup(false);
          setSubscriptionStatus('idle');
        }, 2000);
      } else {
        setSubscriptionStatus('error');
      }
    } catch (error) {
      setSubscriptionStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const featuredProducts = [
    {
      id: 1,
      name: 'ESSENCE HOODIE',
      quote: 'Be the change you wish to see',
      price: 119,
      image: 'https://readdy.ai/api/search-image?query=premium%20black%20luxury%20hoodie%20with%20elegant%20white%20typography%20quote%20printed%20on%20chest%20minimalist%20design%20high%20quality%20organic%20cotton%20fabric%20clean%20simple%20background%20emphasizing%20product%20details%20sophisticated%20streetwear%20aesthetic%20quiet%20luxury%20style%20professional%20product%20photography&width=600&height=800&seq=prod1&orientation=portrait'
    },
    {
      id: 2,
      name: 'CLARITY TEE',
      quote: 'Same shit Different day',
      price: 79,
      image: 'https://readdy.ai/api/search-image?query=premium%20white%20luxury%20t-shirt%20with%20bold%20black%20text%20Same%20shit%20Different%20day%20printed%20in%20modern%20typography%20on%20chest%20minimalist%20design%20high%20quality%20organic%20cotton%20fabric%20clean%20simple%20background%20emphasizing%20product%20details%20sophisticated%20streetwear%20aesthetic%20quiet%20luxury%20style%20professional%20product%20photography&width=600&height=800&seq=prod2v2&orientation=portrait'
    },
    {
      id: 3,
      name: 'WISDOM HOODIE',
      quote: 'Know thyself',
      price: 119,
      image: 'https://readdy.ai/api/search-image?query=premium%20white%20luxury%20hoodie%20with%20elegant%20black%20typography%20quote%20printed%20on%20chest%20minimalist%20design%20high%20quality%20organic%20cotton%20fabric%20clean%20simple%20background%20emphasizing%20product%20details%20sophisticated%20streetwear%20aesthetic%20quiet%20luxury%20style%20professional%20product%20photography&width=600&height=800&seq=prod3&orientation=portrait'
    },
    {
      id: 4,
      name: 'TRUTH TEE',
      quote: 'TOMORROW IS ANOTHER DAY',
      price: 79,
      image: 'https://readdy.ai/api/search-image?query=premium%20black%20luxury%20t-shirt%20with%20elegant%20white%20text%20TOMORROW%20IS%20ANOTHER%20DAY%20printed%20in%20bold%20typography%20on%20chest%20minimalist%20design%20high%20quality%20organic%20cotton%20fabric%20clean%20simple%20background%20emphasizing%20product%20details%20sophisticated%20streetwear%20aesthetic%20quiet%20luxury%20style%20professional%20product%20photography&width=600&height=800&seq=prod4v2&orientation=portrait'
    },
    {
      id: 5,
      name: 'MINDFUL HOODIE',
      quote: 'Present moment, only moment',
      price: 119,
      image: 'https://readdy.ai/api/search-image?query=premium%20grey%20luxury%20hoodie%20with%20elegant%20black%20typography%20quote%20printed%20on%20chest%20minimalist%20design%20high%20quality%20organic%20cotton%20fabric%20clean%20simple%20background%20emphasizing%20product%20details%20sophisticated%20streetwear%20aesthetic%20quiet%20luxury%20style%20professional%20product%20photography&width=600&height=800&seq=prod5&orientation=portrait'
    },
    {
      id: 6,
      name: 'COURAGE TEE',
      quote: 'Don\'t let idiots ruin your day',
      price: 79,
      image: 'https://readdy.ai/api/search-image?query=premium%20white%20luxury%20t-shirt%20with%20bold%20black%20text%20Don%5Ct%20let%20idiots%20ruin%20your%20day%20printed%20in%20modern%20typography%20on%20chest%20minimalist%20design%20high%20quality%20organic%20cotton%20fabric%20clean%20simple%20background%20emphasizing%20product%20details%20sophisticated%20streetwear%20aesthetic%20quiet%20luxury%20style%20professional%20product%20photography&width=600&height=800&seq=prod6v2&orientation=portrait'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SearchModal isOpen={searchModalOpen} onClose={() => setSearchModalOpen(false)} />
      
      {/* Subscription Popup */}
      {showSubscriptionPopup && (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center px-6">
          <div className="bg-white max-w-md w-full p-8 relative">
            <button
              onClick={() => setShowSubscriptionPopup(false)}
              className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center hover:bg-neutral-100 cursor-pointer"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
            
            <h2 className="text-2xl md:text-3xl font-light tracking-[0.2em] text-center mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
              JOIN THE MOVEMENT
            </h2>
            <p className="text-sm text-neutral-600 text-center mb-8">
              Be part of a community that values substance over style, meaning over marketing, and authenticity over everything.
            </p>
            
            <form onSubmit={handleSubscriptionSubmit} data-readdy-form className="space-y-4">
              <input
                type="email"
                name="email"
                placeholder="YOUR EMAIL"
                value={subscriptionEmail}
                onChange={(e) => setSubscriptionEmail(e.target.value)}
                className="w-full px-6 py-4 border border-black/20 text-sm tracking-[0.1em] focus:outline-none focus:border-black"
                required
              />
              
              {subscriptionStatus === 'success' && (
                <div className="p-4 bg-black/5 border border-black/10 text-sm text-center">
                  <i className="ri-check-line text-lg mr-2"></i>
                  Thank you for subscribing!
                </div>
              )}

              {subscriptionStatus === 'error' && (
                <div className="p-4 bg-red-50 border border-red-200 text-sm text-center text-red-600">
                  <i className="ri-error-warning-line text-lg mr-2"></i>
                  Something went wrong. Please try again.
                </div>
              )}
              
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full py-4 bg-black text-white text-sm tracking-[0.2em] hover:bg-neutral-800 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? 'SUBSCRIBING...' : 'SUBSCRIBE'}
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Top Navigation */}
      <nav className="fixed top-0 left-0 right-0 bg-white z-50 border-b border-black/10">
        <div className="px-6 py-4 flex items-center justify-between">
          {/* Mobile: Hamburger on left */}
          <button 
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>

          {/* Desktop: Menu items on left */}
          <div className="hidden md:flex items-center gap-8">
            <Link to="/shop" className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer">NEW ARRIVALS</Link>
            <div 
              className="relative"
              onMouseEnter={() => setCollectionDropdownOpen(true)}
              onMouseLeave={() => setCollectionDropdownOpen(false)}
            >
              <button className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer flex items-center gap-1">
                COLLECTION
                <i className="ri-arrow-down-s-line text-lg"></i>
              </button>
              {collectionDropdownOpen && (
                <div className="absolute top-full left-0 pt-2">
                  <div className="bg-white border border-black/10 py-2 min-w-[160px] shadow-lg">
                    <Link to="/hoodies" className="block px-6 py-2 text-sm tracking-[0.2em] hover:bg-neutral-50 cursor-pointer">
                      HOODIES
                    </Link>
                    <Link to="/tees" className="block px-6 py-2 text-sm tracking-[0.2em] hover:bg-neutral-50 cursor-pointer">
                      T-SHIRTS
                    </Link>
                  </div>
                </div>
              )}
            </div>
            <Link to="/about" className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer">ABOUT</Link>
          </div>

          {/* Logo in center */}
          <Link to="/" className="cursor-pointer absolute left-1/2 transform -translate-x-1/2">
            <img 
              src="https://static.readdy.ai/image/6ad45fecb24f9c50dfb1488fc3ba7d2f/1bfa6c5bfe10d7e974b284f405d55895.png" 
              alt="DASHY" 
              className="h-7 md:h-8"
            />
          </Link>
          
          {/* Icons on right */}
          <div className="flex items-center gap-4">
            <button 
              onClick={() => setSearchModalOpen(true)}
              className="w-10 h-10 hidden md:flex items-center justify-center cursor-pointer"
            >
              <i className="ri-search-line text-xl"></i>
            </button>
            <Link to="/wishlist" className="w-10 h-10 flex items-center justify-center cursor-pointer relative">
              <i className="ri-heart-line text-xl"></i>
              {wishlistTotal > 0 && (
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-black text-white text-xs flex items-center justify-center rounded-full">
                  {wishlistTotal}
                </span>
              )}
            </Link>
            <Link to="/cart" className="w-10 h-10 flex items-center justify-center cursor-pointer relative">
              <i className="ri-shopping-bag-line text-xl"></i>
              {totalItems > 0 && (
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-black text-white text-xs flex items-center justify-center rounded-full">
                  {totalItems}
                </span>
              )}
            </Link>
          </div>
        </div>

        {/* Mobile Menu Dropdown */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-black/10 bg-white">
            <div className="px-6 py-4 flex flex-col gap-4">
              <Link to="/shop" className="text-sm tracking-[0.15em] hover:opacity-60 transition-opacity cursor-pointer" onClick={() => setMobileMenuOpen(false)}>NEW ARRIVALS</Link>
              <div>
                <button 
                  onClick={() => setCollectionDropdownOpen(!collectionDropdownOpen)}
                  className="text-sm tracking-[0.15em] hover:opacity-60 transition-opacity cursor-pointer flex items-center gap-1 w-full"
                >
                  COLLECTION
                  <i className={`ri-arrow-${collectionDropdownOpen ? 'up' : 'down'}-s-line text-lg`}></i>
                </button>
                {collectionDropdownOpen && (
                  <div className="pl-4 mt-2 space-y-2">
                    <Link to="/hoodies" className="block text-sm tracking-[0.15em] text-neutral-600 hover:opacity-60 transition-opacity cursor-pointer" onClick={() => setMobileMenuOpen(false)}>
                      HOODIES
                    </Link>
                    <Link to="/tees" className="block text-sm tracking-[0.15em] text-neutral-600 hover:opacity-60 transition-opacity cursor-pointer" onClick={() => setMobileMenuOpen(false)}>
                      T-SHIRTS
                    </Link>
                  </div>
                )}
              </div>
              <Link to="/about" className="text-sm tracking-[0.15em] hover:opacity-60 transition-opacity cursor-pointer" onClick={() => setMobileMenuOpen(false)}>ABOUT</Link>
              <div className="flex gap-4 pt-4 border-t border-black/10">
                <button 
                  onClick={() => {
                    setSearchModalOpen(true);
                    setMobileMenuOpen(false);
                  }}
                  className="w-10 h-10 flex items-center justify-center cursor-pointer"
                >
                  <i className="ri-search-line text-xl"></i>
                </button>
                <Link to="/cart" className="w-10 h-10 flex items-center justify-center cursor-pointer relative" onClick={() => setMobileMenuOpen(false)}>
                  <i className="ri-shopping-bag-line text-xl"></i>
                  {totalItems > 0 && (
                    <span className="absolute -top-1 -right-1 w-5 h-5 bg-black text-white text-xs flex items-center justify-center rounded-full">
                      {totalItems}
                    </span>
                  )}
                </Link>
                <Link to="/wishlist" className="w-10 h-10 flex items-center justify-center cursor-pointer relative" onClick={() => setMobileMenuOpen(false)}>
                  <i className="ri-heart-line text-xl"></i>
                  {wishlistTotal > 0 && (
                    <span className="absolute -top-1 -right-1 w-5 h-5 bg-black text-white text-xs flex items-center justify-center rounded-full">
                      {wishlistTotal}
                    </span>
                  )}
                </Link>
              </div>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section - Slideshow Banner */}
      <div className="relative h-[60vh] sm:h-[70vh] md:h-[80vh] lg:h-screen mt-[73px] overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30 z-10"></div>
        {heroImages.map((image, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img 
              src={image}
              alt={`DASHY Collection ${index + 1}`}
              className="w-full h-full object-cover object-center md:object-top"
            />
          </div>
        ))}
      </div>

      {/* Featured Products */}
      <section className="py-20 md:py-32 px-6" data-product-shop>
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-light tracking-[0.15em] md:tracking-[0.2em] text-center mb-12 md:mb-20" style={{ fontFamily: '"Playfair Display", serif' }}>
            FEATURED PIECES
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {featuredProducts.map(product => (
              <Link 
                key={product.id}
                to={`/product/${product.id}`}
                className="group cursor-pointer"
              >
                <div className="aspect-[3/4] bg-neutral-50 mb-4 overflow-hidden">
                  <img 
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <h3 className="text-xs md:text-sm tracking-[0.15em] md:tracking-[0.2em] mb-2">{product.name}</h3>
                <p className="text-xs text-neutral-500 italic mb-2">"{product.quote}"</p>
                <p className="text-sm">{convertPrice(product.price)}</p>
              </Link>
            ))}
          </div>
          
          <div className="text-center mt-12 md:mt-16">
            <Link 
              to="/shop"
              className="inline-block px-8 md:px-12 py-3 md:py-4 border border-black text-xs md:text-sm tracking-[0.2em] md:tracking-[0.3em] hover:bg-black hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              VIEW ALL PRODUCTS
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-12 md:py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12">
            <div>
              <h3 className="text-xs md:text-sm tracking-[0.15em] md:tracking-[0.2em] mb-4 md:mb-6">DASHY</h3>
              <p className="text-xs md:text-sm text-neutral-400 leading-relaxed">
                Quiet luxury streetwear with meaningful messages for the modern individual.
              </p>
            </div>
            
            <div>
              <h4 className="text-xs md:text-sm tracking-[0.15em] md:tracking-[0.2em] mb-3 md:mb-4">SHOP</h4>
              <ul className="space-y-2 md:space-y-3 text-xs md:text-sm text-neutral-400">
                <li><Link to="/shop" className="hover:text-white transition-colors cursor-pointer">New Arrivals</Link></li>
                <li><Link to="/shop" className="hover:text-white transition-colors cursor-pointer">Hoodies</Link></li>
                <li><Link to="/shop" className="hover:text-white transition-colors cursor-pointer">T-Shirts</Link></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-xs md:text-sm tracking-[0.15em] md:tracking-[0.2em] mb-3 md:mb-4">COMPANY</h4>
              <ul className="space-y-2 md:space-y-3 text-xs md:text-sm text-neutral-400">
                <li><Link to="/about" className="hover:text-white transition-colors cursor-pointer">About Us</Link></li>
                <li><Link to="/contact" className="hover:text-white transition-colors cursor-pointer">Contact Us</Link></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-xs md:text-sm tracking-[0.15em] md:tracking-[0.2em] mb-3 md:mb-4">FOLLOW US</h4>
              <div className="flex gap-4">
                <a href="https://instagram.com/Dashyfashionofficial" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/20 hover:bg-white hover:text-black transition-all cursor-pointer">
                  <i className="ri-instagram-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>
          
          <div className="pt-6 md:pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-3 md:gap-4 text-xs md:text-sm text-neutral-400">
            <div className="flex items-center gap-3">
              <p className="text-center md:text-left">© 2024 DASHY FASHION LIMITED. All rights reserved.</p>
            </div>
            <div className="flex gap-4 md:gap-6">
              <Link to="/privacy" className="hover:text-white transition-colors cursor-pointer">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-white transition-colors cursor-pointer">Terms of Service</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}